import { getBitDays } from '@/module/util'

const DayInfo = ['Su', 'Mo', 'Tu', 'W', 'Th', 'F', 'Sa']

export default function(patient, medications) {
    var result = []

    result.push(patient.name, ' takes ', medications.length, ' medication', medications.length == 1 ? ': ' : 's: ', '\n')

    // Sorting alphabetically by name
    medications.sort((medA, medB) => {
        if(medA.name.toLowerCase() < medB.name.toLowerCase()) 
            return -1
        if(medA.name.toLowerCase() > medB.name.toLowerCase())
            return 1
        return 0
    } )

    medications.forEach((medication, i) => {
        result.push('<b>', medication.name, ', ', medication.dose, '</b>')
        // If medicine record exist than sum all values for the key
        try {
            if(medication.record)
                result.push(', ' + Object.values(medication.record).reduce((total, time) => total + time, 0) + 'x')
        } catch (error) {
            console.error('Error getting medication record sum', error)
        }

        if(medication.as_needed)
            result.push(', As Needed')
        else if(medication.day)
            result.push(', ' + getBitDays(medication.day))
        result.push('\n')
    })

    return result.join('')
}

export function getCompleteWeekString(activeDaysString) {
    if (activeDaysString === 'All Days')
        return activeDaysString
    let string = ''
    let activeDaysArray = activeDaysString.split(' ')
    DayInfo.forEach(day => {
        if (activeDaysArray.includes(day))
            string += (day + ' ')
        else
            string += ('<span style="color: #ccc">' + day + '</span> ')
    })
    return string
}

export function getMedicationString(medication) {
    let result = []
    // result.push(medication.dose)
    // If medicine record exist than sum all values for the key
    try {
        if(medication.record)
            result.push(Object.values(medication.record).reduce((total, time) => total + time, 0) + 'x')
    } catch (error) {
        console.error('Error getting medication record sum', error)
    }
    
    if(medication.as_needed)
        result.push('As Needed')
    else if(medication.day)
        result.push(', ' + getCompleteWeekString(getBitDays(medication.day)))
    return result.join('')
}